@if (showChrome()) {
	<div class="shell">
		<app-sidebar />
		<main class="shell-main">
			<router-outlet />
		</main>
	</div>
} @else {
	<router-outlet />
}
